import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 报表模块
 */

export const BigData = {
    // 报表1 ,站点运行率
    getChart0(parmas, expend) {
        return send("GET", "/api/company/bigData/chart0", parmas, expend);
    },
    // 报表1 ,站点
    getChart1(parmas, expend) {
        return send("GET", "/api/company/bigData/chart1", parmas, expend);
    },
    // 报表2 设备
    getChart2(parmas, expend) {
        return send("GET", "/api/company/bigData/chart2", parmas, expend);
    },
    // 报表3 月
    getChart3(parmas, expend) {
        return send("GET", "/api/company/bigData/chart3", parmas, expend);
    },
    // 报表4 小时
    getChart4(parmas, expend) {
        return send("GET", "/api/company/bigData/chart4", parmas, expend);
    },
}